











































import { Component, Inject } from 'vue-property-decorator';
import GraduationHatIcon from '@/components/Helper/Icon/Svg/GraduationHatIcon.vue';
import { UseService } from '@/services/service';
import VuePdf from 'vue-pdf/src/vuePdfSss.vue';
import LessonBaseMixin from '@/components/ViewComponent/ELearning/lesson-base-mixin';
import LearningProgressService from '@/services/learning-progress.service';
import { LearningProgressEntity } from '@/entities/learning-progress.entity';

@Component<Learn>({
  components: { GraduationHatIcon, VuePdf },
})
export default class Learn extends LessonBaseMixin {
  @Inject('toggleSideDrawer')
  toggleSideDrawer!: () => any;

  currentPage = 1;

  pageCount = 0;

  progress: LearningProgressEntity = null;

  @UseService(LearningProgressService)
  progressService: LearningProgressService;

  async mounted(): Promise<void> {
    this.progress = await this.progressService.getLessonProgress(this.lessonId);
    if (this.progress) {
      this.currentPage = this.progress.currentPage || 1;
    }
  }

  changePage(page: number): void {
    if (page > 0 && page <= this.pageCount) {
      this.currentPage = page;
    }
  }

  loadedPage(page: number): void {
    this.currentPage = page;
    this.progressService.readPage(this.lessonId, page);
  }

  nextPage(): void {
    this.changePage(this.currentPage + 1);
  }

  previousPage(): void {
    this.changePage(this.currentPage - 1);
  }
}
